export class StringHelpers {
    public static distanceToReadable(distance:number, prepend:string="", append:string="") {
        if(distance==null||isNaN(distance)) return "";
        let unit = "meter";
        if(distance>10*1000) {
            unit = "mil";
        } else if(distance>1000) {
            unit = "km";
        }
        if(unit=="km") return prepend+(distance/1000).toFixed(1)+" "+unit+append;
        if(unit=="mil") return prepend+(distance/10000).toFixed(1)+" "+unit+append;
        return prepend+Math.round(distance)+" "+unit+append;
    }

    public static getStringFragments(str:string):Array<string> {
        if(str==null||str=="") return null;
        let searchLowerFragmentString = str.replace(/,/gi, " ");
        searchLowerFragmentString = searchLowerFragmentString.replace(/-/gi, " ");
        searchLowerFragmentString = searchLowerFragmentString.replace(/  /gi, " ");
        return searchLowerFragmentString.split(" ");
    }
    public static search(subject:string, search:string):number {
        if(subject==null||search==null) return 0;
        let subjectLower:string = subject.toLowerCase();
        let searchLower:string = search.toLowerCase();
        if(subjectLower.indexOf(searchLower)==0) return 10;
        if(subjectLower.indexOf(searchLower)>-1) return 8;
        let searchFragments = StringHelpers.getStringFragments(searchLower);
        let score:number = 0;
        let wordnum:number = 0;
        for(let m in searchFragments) {
            let cFragment:string = searchFragments[m];
            if(cFragment.length<=2) continue; //ignore if too short
            let matchIndex:number = subjectLower.indexOf(cFragment);
            if(matchIndex>=0) {
                let addscore:number = 1;
                if(matchIndex<10) addscore = 3;
                if(matchIndex==0) addscore = 5;
                score+=addscore;
            }
            wordnum++;
        }
        return score;
    }
}